import React, { useEffect } from "react";
import CollapseTable from "../../components/tables/CollapseTable";
import {
  getDefaultLimit,
  usePagination,
} from "../../hooks/pagination/usePagination";
import {
  registerHooks,
  registerQuery,
} from "../../hooks/handlers/useRegisterHandler";
import { changeToSnakeCase } from "../../utils/helpers";
import { query } from "firebase/firestore";
import { CreateDrawer } from "../../components/drawer/DrawerComponent";
import { FormLayoutHandler } from "./FormLayoutHandler";

export const RegisterLayoutHandler = ({ source, title }) => {
  const source_key = changeToSnakeCase(source);

  // get source hooks
  const hook = registerHooks[source_key];
  const {
    tableData = () => {},
    tableColumns = () => {},
    form,
    header,
  } = hook ? hook() : {};

  const dataQuery = registerQuery[source_key];

  // default pagination
  const {
    fetchMore,
    paginatedList: sourceData,
    getList: getSourceData,
    loading,
  } = usePagination(query(dataQuery, getDefaultLimit()));

  // get data
  useEffect(() => {
    if (dataQuery) getSourceData();
  }, [source]);

  const FormComponent = () => (
    <FormLayoutHandler key={form?.source} source={form?.source} />
  );

  return (
    <div>
      <h3>{title}</h3>
      {/* HEADER */}
      {header && header()}
      {/* FORM ACTION */}
      {form && (
        <CreateDrawer
          title={form?.title || `New ${form.source}`}
          form={<FormComponent />}
        />
      )}
      {/* TABLE */}
      <CollapseTable
        loading={loading}
        columns={tableColumns()}
        rows={tableData(sourceData)}
        fetchMore={fetchMore}
      />
    </div>
  );
};
